import React from 'react';
import { LinkMessage } from '../CoverQuiz/publicQuizLink';
import { QuizLangProvider, QuizLangSwitcher, usePageQuizLang } from '../CoverQuiz/quizLang';
import './CareerQuiz.scss';

/**
 * `/career-quiz?p=…` — the 職涯測驗 link the first, localStorage-only version
 * handed out (quizToken.ts, since removed). Those links carry no server token,
 * so nothing they lead to can reach the adviser any more. Rather than drop the
 * candidate on the login page, say the link is spent and who gives a new one —
 * the same 連結已失效 a withdrawn `/r/<token>` link shows.
 */
const RetiredQuizLink = () => {
  const [lang, setLang] = usePageQuizLang(undefined, '');
  return (
    <QuizLangProvider value={lang}>
      <div className="career-quiz-page" data-testid="career-quiz" lang={lang}>
        <div className="career-quiz-container">
          <QuizLangSwitcher lang={lang} onChange={setLang} testId="career-quiz-lang" />
          <LinkMessage state="invalid" testIdPrefix="career-quiz" className="cq-card cq-link-message" />
        </div>
      </div>
    </QuizLangProvider>
  );
};

export default RetiredQuizLink;
